import { InlineNotification } from "@carbon/react";
import { useSpring, animated } from 'react-spring'

// eslint-disable-next-line
export default (props) => {
    const loadingAnimation = useSpring({ 
        from: { opacity: 1 }, 
        to: { opacity: 0 }, 
        delay: 3000,
        config: { duration: 600 }
    });
    const removeAnimation = useSpring({ 
        from: { display: "inline" }, 
        to: { display: "none" }, 
        delay: 3600,
        config: { duration: 0 }
    });

    return (
        <>
            {props.isLoading && <InlineNotification
                kind={'info'}
                subtitle="Processing Request"
                title="Loading"
                hideCloseButton={true}
            />

            }
            {props.isError && <InlineNotification
                kind={'error'}
                subtitle={Array.isArray(props.errorMessage) ? props.errorMessage.join(', ') : props.errorMessage.toString()}
                title="Error"
                hideCloseButton={true}
            />}
            {props.isSuccess && <animated.div style={loadingAnimation}>
                <animated.div style={removeAnimation}>
                    <InlineNotification
                        kind={'success'}
                        subtitle={props.successMessage}
                        title="Success"
                        hideCloseButton={true}
                    />
                </animated.div>
            </animated.div>}
            {props.isPermanentSuccess && <InlineNotification
                kind={'success'}
                subtitle={props.successMessage}
                title="Success"
                hideCloseButton={true}
            />}
            {props.isSuccess && props.children}
        </>
    )
}
